import { Providers } from '@/components/providers';
import { AppRoutes } from '@/routes';

export function App() {
  return (
    <Providers>
      <AppRoutes />
    </Providers>
  );
}
